var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4409 15.224C38.0674 13.917 37.1338 12.9833 35.8268 12.6099C31.9056 12.2365 27.9843 11.863 24.0631 12.0497C20.1419 12.0497 16.2207 12.2365 12.2995 12.6099C11.1792 12.9833 10.0588 14.1037 9.6854 15.224C8.9408 21.051 8.9408 26.9491 9.6854 32.7761C10.0588 34.0832 10.9925 35.0168 12.2995 35.3902C16.2207 35.7637 20.1419 36.1371 24.0631 35.9504C27.9843 35.9504 31.9056 35.7637 35.8268 35.3902C37.1338 35.0168 38.0674 34.0832 38.4409 32.7761C39.1855 26.9491 39.1855 21.051 38.4409 15.224ZM20.3287 29.6018V18.3983L30.0383 24.0001L20.3287 29.6018Z",
    fill: "#000021"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.0bcf306d.svg";
export { ForwardRef as ReactComponent };